module.exports = "<div class=\"home\"> <div class=\"home__pattern\"> <header class=\"header--purple2\"> <div class=\"container\"> <a routerLink=\"../\" class=\"header__logo--compact-white\"></a> </div> </header> </div> <section class=\"section\"> <div style=\"text-align:center\"> <h1>404</h1> <p>Page not found</p> </div> </section> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/marketing/error-404.component.html
// module id = ./src/app/marketing/error-404.component.html
// module chunks = 21